// import { red } from '@material-ui/core/colors';
import darkTheme from './dark';
import lightTheme from './light';

export default {
  light: lightTheme,
  dark: darkTheme,
};
